const parseFrontmatter = (raw) => {
  // Normalize CRLF to LF
  const normalized = raw.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const match = normalized.match(/^---\n([\s\S]*?)\n---\n([\s\S]*)$/);
  if (!match) return { data: {}, content: normalized };

  const data = {};
  const lines = match[1].split('\n');
  let currentKey = null;

  lines.forEach((line) => {
    // Continuation line (indented) — append to previous key
    if (currentKey && line.startsWith('  ')) {
      data[currentKey] += ' ' + line.trim();
      return;
    }
    const colon = line.indexOf(':');
    if (colon === -1) return;
    currentKey = line.slice(0, colon).trim();
    const value = line.slice(colon + 1).trim().replace(/^["']|["']$/g, '');
    data[currentKey] = value;
  });

  return { data, content: match[2].trim() };
};

export const fetchAllPosts = async () => {
  try {
    const res = await fetch('/content/blogs/index.json');
    if (!res.ok) return [];
    const slugs = await res.json();
    const results = await Promise.all(
      slugs.map(async (slug) => {
        try {
          const r = await fetch(`/content/blogs/${slug}.md`);
          if (!r.ok) return null;
          const raw = await r.text();
          const { data, content } = parseFrontmatter(raw);
          // Always use filename as slug (source of truth)
          return { ...data, slug, content };
        } catch {
          return null;
        }
      })
    );
    return results
      .filter(Boolean)
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  } catch {
    return [];
  }
};

export const fetchPost = async (slug) => {
  try {
    const res = await fetch(`/content/blogs/${slug}.md`);
    if (!res.ok) return null;
    const raw = await res.text();
    const { data, content } = parseFrontmatter(raw);
    // Always use filename as slug
    return { ...data, slug, content };
  } catch {
    return null;
  }
};
